export default {
	title: 'पोर्टफोलियो',
	description: 'मेरे सभी Gerositus प्रोजेक्ट',
	actions: {
		back_to_this: 'पोर्टफोलियो पर वापस जाएँ'
	},
	search_projects: 'प्रोजेक्ट खोजें',
	cta: {
		welcome:
			'Gerositus Strategy Suite से जुड़ने के लिए आपका स्वागत है और धन्यवाद!',
		subscribe: 'अभी सदस्यता लें',
		create_permission: 'नए प्रोजेक्ट बनाने में सक्षम होने के लिए।'
	},
	tabs: {
		risks: {
			title: 'जोखिम और अवसर सेटिंग्स'
		}
	}
};
